<template>
  <!--====== APPIE FAQ PART START ======-->
    
    <section class="appie-faq-area pb-95" id="faq">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="appie-section-title text-center">
                        <h3 class="appie-title">{{title}}</h3>
                        <p>{{description}}</p>
                    </div>                    
                </div>
            </div>
            <div class="row">
                <div class="col-lg-6">
                    <div class="faq-accordion wow fadeInRight mt-30" data-wow-duration="1500ms">
                        <div class="accrodion-grp animated fadeIn faq-accrodion wow" data-wow-duration="1500ms" data-grp-name="faq-accrodion">
                            <div class="accrodion" @click.prevent="OpenQuestion(1)" :class="[showQuestion === 1?'active':'']">
                                <div class="accrodion-inner">
                                    <div class="accrodion-title">
                                        <h4>How do I redeem my eGift?</h4>
                                    </div>
                                    <div class="accrodion-content" :style="[showQuestion === 1?{'display':'block'}:{'display':'none'}]">
                                        <div class="inner">
                                            <p>
                                                1- Click "Menu" Icon (Top Left Corner) <br>  
                                                2- Press "Settings" <br>
                                                3- Choose Your eGift <br>
                                                4- Press "Request My eGift
                                            </p>
                                        </div><!-- /.inner -->
                                    </div>
                                </div><!-- /.accrodion-inner -->
                            </div>
                            <div class="accrodion  " :class="[showQuestion === 2?'active':'']" @click.prevent="OpenQuestion(2)">
                                <div class="accrodion-inner">
                                    <div class="accrodion-title">
                                        <h4>How long it takes for my pictures to get approved?</h4>
                                    </div>
                                    <div class="accrodion-content" :style="[showQuestion === 2?{'display':'block'}:{'display':'none'}]">
                                        <div class="inner">
                                            <p>• It takes about 24 - 48 Hours</p>
                                        </div><!-- /.inner -->
                                    </div>
                                </div><!-- /.accrodion-inner -->
                            </div>
                            <div class="accrodion  " :class="[showQuestion === 3?'active':'']" @click.prevent="OpenQuestion(3)">
                                <div class="accrodion-inner">
                                    <div class="accrodion-title">
                                        <h4>How many pictures do I need to take before I can redeem my eGift?</h4>
                                    </div>
                                    <div class="accrodion-content" :style="[showQuestion === 3?{'display':'block'}:{'display':'none'}]">
                                        <div class="inner">
                                            <p>• You may need to take 10 pictures or collect $10 at least</p>
                                        </div><!-- /.inner -->
                                    </div>
                                </div><!-- /.accrodion-inner -->
                            </div>
                            <div class="accrodion  " :class="[showQuestion === 12?'active':'']" @click.prevent="OpenQuestion(12)">
                                <div class="accrodion-inner">
                                    <div class="accrodion-title">
                                        <h4>How does Reward Points work?</h4>
                                    </div>
                                    <div class="accrodion-content" :style="[showQuestion === 12?{'display':'block'}:{'display':'none'}]">
                                        <div class="inner">
                                            <p> 
                                               • For every $10 you spend you will receive 1 Reward Point. <br>
                                               • For every item you rate you will receive 1 Reward Point.
                                            </p>
                                        </div><!-- /.inner -->
                                    </div>
                                </div><!-- /.accrodion-inner -->
                            </div>
                            <div class="accrodion  " :class="[showQuestion === 13?'active':'']" @click.prevent="OpenQuestion(13)">
                                <div class="accrodion-inner">
                                    <div class="accrodion-title">
                                        <h4>How many much each Reward Points worth?</h4>
                                    </div>
                                    <div class="accrodion-content" :style="[showQuestion === 13?{'display':'block'}:{'display':'none'}]">
                                        <div class="inner">
                                            <p> 
                                               • For every 10 points you can get $1 eGift from your favorite food delivery app companies.
                                            </p>
                                        </div><!-- /.inner -->
                                    </div>
                                </div><!-- /.accrodion-inner -->
                            </div>
                            <div class="accrodion  " :class="[showQuestion === 4?'active':'']" @click.prevent="OpenQuestion(4)">
                                <div class="accrodion-inner">
                                    <div class="accrodion-title">
                                        <h4>What qualifies an approved picture?</h4>
                                    </div>
                                    <div class="accrodion-content" :style="[showQuestion === 4?{'display':'block'}:{'display':'none'}]">
                                        <div class="inner">
                                            <p>
                                                •   Clear / Not blurry <br>
                                                •   No editing software was used to enhance your picture(s) <br>
                                                •   All elements of the item(s) are included in your picture(s) <br>
                                                •   The picture needs to be original, you cannot post pictures taken from other sources
                                            </p>
                                        </div><!-- /.inner -->
                                    </div>
                                </div><!-- /.accrodion-inner -->
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="faq-accordion wow fadeInRight mt-30" data-wow-duration="1500ms">
                        <div class="accrodion-grp animated fadeIn faq-accrodion wow" data-wow-duration="1500ms" data-grp-name="faq-accrodion">
                            <div class="accrodion " :class="[showQuestion === 5?'active':'']" @click.prevent="OpenQuestion(5)">
                                <div class="accrodion-inner">
                                    <div class="accrodion-title">
                                        <h4>How do I request a new restaurant that's not on the TroFii app yet?</h4>
                                    </div>
                                    <div class="accrodion-content" :style="[showQuestion === 5?{'display':'block'}:{'display':'none'}]">
                                        <div class="inner">
                                            <p>• You can type the restaurant name in the search box in the "Restaurant" tab to add it.</p>
                                        </div><!-- /.inner -->
                                    </div>
                                </div><!-- /.accrodion-inner -->
                            </div>
                            <div class="accrodion" :class="[showQuestion ===6?'active':'']" @click.prevent="OpenQuestion(6)">
                                <div class="accrodion-inner">
                                    <div class="accrodion-title">
                                        <h4>Can I split my points from my eGift?</h4>
                                    </div>
                                    <div class="accrodion-content" :style="[showQuestion === 6?{'display':'block'}:{'display':'none'}]">
                                        <div class="inner">
                                            <p>• No, you need to choose a mode of delivery, whether it is on GrubHub, DoorDash, or Uber Eats.</p>
                                        </div><!-- /.inner -->
                                    </div>
                                </div><!-- /.accrodion-inner -->
                            </div>
                            <div class="accrodion" :class="[showQuestion ===7?'active':'']" @click.prevent="OpenQuestion(7)">
                                <div class="accrodion-inner">
                                    <div class="accrodion-title">
                                        <h4>Can I change my eGift option?</h4>
                                    </div>
                                    <div class="accrodion-content" :style="[showQuestion === 7?{'display':'block'}:{'display':'none'}]">
                                        <div class="inner">
                                            <p>• Yes, each time you redeem your points you can change the mode of delivery for your eGift.</p>
                                        </div><!-- /.inner -->
                                    </div>
                                </div><!-- /.accrodion-inner -->
                            </div>
                            <div class="accrodion" :class="[showQuestion ===8?'active':'']" @click.prevent="OpenQuestion(8)">
                                <div class="accrodion-inner">
                                    <div class="accrodion-title">
                                        <h4>Do my points expire?</h4>
                                    </div>
                                    <div class="accrodion-content" :style="[showQuestion === 8?{'display':'block'}:{'display':'none'}]">
                                        <div class="inner">
                                            <p>• Your points never expire.</p>
                                        </div><!-- /.inner -->
                                    </div>
                                </div><!-- /.accrodion-inner -->
                            </div>
                            <div class="accrodion" :class="[showQuestion ===9?'active':'']" @click.prevent="OpenQuestion(9)">
                                <div class="accrodion-inner">
                                    <div class="accrodion-title">
                                        <h4>What are the minimum requirements to redeem my eGift?</h4>
                                    </div>
                                    <div class="accrodion-content" :style="[showQuestion === 9?{'display':'block'}:{'display':'none'}]">
                                        <div class="inner">
                                            <p>• You need to collect at least $10 or get 10 pictures approved.</p>
                                        </div><!-- /.inner -->
                                    </div>
                                </div><!-- /.accrodion-inner -->
                            </div>
                            <div class="accrodion  " :class="[showQuestion === 10?'active':'']" @click.prevent="OpenQuestion(10)">
                                <div class="accrodion-inner">
                                    <div class="accrodion-title">
                                        <h4>How can I earn reward points?</h4>
                                    </div>
                                    <div class="accrodion-content" :style="[showQuestion === 10?{'display':'block'}:{'display':'none'}]">
                                        <div class="inner">
                                            <p> 1- Rate your favorite food.<br>
                                                2- Upload your receipt from participating restaurants. 
                                            </p>
                                        </div><!-- /.inner -->
                                    </div>
                                </div><!-- /.accrodion-inner -->
                            </div>
                            <div class="accrodion  " :class="[showQuestion === 11?'active':'']" @click.prevent="OpenQuestion(11)">
                                <div class="accrodion-inner">
                                    <div class="accrodion-title">
                                        <h4>How can I upload my receipt?</h4>
                                    </div>
                                    <div class="accrodion-content" :style="[showQuestion === 11?{'display':'block'}:{'display':'none'}]">
                                        <div class="inner">
                                            <p> 1- Click "Menu" Icon (Top Left Corner) <br>  
                                                2- Press "Upload Receipts" <br>
                                                3- Click "Receipt" Icon (Top Right Corner) <br>
                                                4- Upload your receipt
                                            </p>
                                        </div><!-- /.inner -->
                                    </div>
                                </div><!-- /.accrodion-inner -->
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-12">
                    <div class="faq-text text-center pt-40">
                        <p>Can't find an answer? <a style="font-size: 18px; color: #C90611" href="mailto:Support@TroFii.Net">Email us</a></p>
                    </div>
                </div>
            </div>
        </div>
    </section>
    
    <!--====== APPIE FAQ PART ENDS ======-->
</template>

<script>
export default {
    props:{
        title:{
            type:String,
        },
        description:{
            type:String,
        }
    },
   data(){
       return {
           showQuestion:1,
       }
   },
    methods: {
        OpenQuestion(value){
            this.showQuestion = value
        }
    }

}
</script>

<style>

</style>